"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isArray = _interopRequireDefault(require("lodash/fp/isArray"));

var _map = _interopRequireDefault(require("lodash/fp/map"));

var _toPairs = _interopRequireDefault(require("lodash/fp/toPairs"));

var renderList = function renderList(notes) {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: 'margin-bottom-0 margin-left-5 padding-left-25'
  }, notes);
};

var renderNode = function renderNode(content) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'padding-left-10'
  }, content);
};

var getNotes = function getNotes(content, version) {
  return (0, _map.default)(function (point) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "".concat(version, "-note-").concat(Math.random())
    }, point);
  }, content);
};

var renderNotes = function renderNotes(note, version) {
  var date = note.date,
      content = note.content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'panel panel-default',
    key: "".concat(version, "-note")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'panel-heading'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'display-flex justify-content-between'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'text-size-16 text-medium'
  }, "".concat(version)), /*#__PURE__*/_react.default.createElement("span", {
    className: 'text-muted text-thin'
  }, date))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'panel-body white-space-pre-line'
  }, (0, _isArray.default)(content) ? renderList(getNotes(content, version)) : renderNode(content)));
};

var getReleases = function getReleases(_ref) {
  var releaseNotes = _ref.releaseNotes;
  return (0, _map.default)(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        key = _ref3[0],
        note = _ref3[1];

    return renderNotes(note, key);
  }, (0, _toPairs.default)(releaseNotes));
};

var ReleaseNotes = function ReleaseNotes(props) {
  return /*#__PURE__*/_react.default.createElement("div", null, getReleases(props));
};

ReleaseNotes.defaultProps = {};
ReleaseNotes.propTypes = {
  releaseNotes: _propTypes.default.object
};
var _default = ReleaseNotes;
exports.default = _default;